@switch (columnName) {
  @case ('expires') {
    @if (element[columnName]) {
      {{ element[columnName] | date }}
    } @else {
      {{ 'noExpiry' | translate }}
    }
  }
  @case ('medicineCategory') {
    {{ element.category?.name }}
  }
  @case ('quantityType') {
    {{ element.quantityType?.name }}
  }
  @case ('responsible') {
    @for (position of element.responsibleForPositions ?? []; track $index) {
      <div>
        {{ position?.name }}
      </div>
    }
    @for (positionGroup of element.responsibleForPositionGroups ?? []; track $index) {
      <div>
        {{ positionGroup?.name }}
      </div>
    }
    @for (role of element.responsibleForRoles ?? []; track $index) {
      <div>
        {{ role?.name }}
      </div>
    }
  }
  @case ('minQuantity') {
    {{ element.minimumQuantity }}
  }
  @case ('refrigerated') {
    @if (element.shouldBeRefrigerated) {
      <mat-icon>ac_unit</mat-icon>
    }
  }
  @case ('stockStatus') {
    <app-ui-pill [name]="statusColor"></app-ui-pill>
  }
  @case ('expiryStatus') {
    <app-ui-pill [name]="expiryStatusColor"></app-ui-pill>
  }
  @case ('description') {
    {{ element.reason }}
  }
  @case ('date') {
    {{ element.date | date }}
  }
  @case ('changedBy') {
    {{ element.changedBy | fullName }}
  }
  @case ('event') {
    {{ element.medicineEvent | mapMedicineEvent | translate }}
  }
  @case ('departments') {
    @for (department of element.departments; track $index) {
      <div>
        {{ department.name }}
      </div>
    }
    @for (departmentGroup of element.departmentGroups; track $index) {
      <div>
        {{ departmentGroup.name }}
      </div>
    }
  }
  @case ('actionButton') {
    <div class="display-flex">
      <app-ui-button
        text="{{ 'addToStock' | translate }}"
        buttonType="secondary"
        (click)="addToStock()"
        [loading]="(addToStockActions | actionInProgress: false : matchesRow | async) === true"
        privilege="MEDICINE_UPDATE"
      ></app-ui-button>
      <app-ui-button
        class="use-button"
        buttonType="secondary"
        text="{{ 'use' | translate }}"
        (click)="use()"
        [loading]="(useActions | actionInProgress: false : matchesRow | async) === true"
        privilege="MEDICINE_UPDATE"
      ></app-ui-button>
    </div>
  }
  @default {
    <app-default-cell [element]="element" [columnName]="columnName"></app-default-cell>
  }
}
